import { AnalyticsContextValue } from "@swiggy-private/checkout-core";
import { SwiggySixesCommState } from "@swiggy-private/cart-types";
import { SCREEN_NAME, CLICK_ACTIONS, IMPRESSION_ACTIONS } from "../constants";

export interface SSFloatyAnalyticsContext {
    state: "six hit" | "consecutive six";
    timer: string;
}

const formatState = (state?: SwiggySixesCommState): "six hit" | "consecutive six" =>
    state === SwiggySixesCommState.CONSECUTIVE_SIXES_HIT ? "consecutive six" : "six hit";

const formatTimer = (minutes: number, seconds: number): string =>
    `${minutes}:${seconds.toString().padStart(2, "0")}`;

export const getSSFloatyContext = (
    croutonState: SwiggySixesCommState | undefined,
    tickerValue: { minutes?: number; seconds?: number },
): SSFloatyAnalyticsContext => {
    const minutes = tickerValue.minutes ?? 0;
    const seconds = tickerValue.seconds ?? 0;
    return { state: formatState(croutonState), timer: formatTimer(minutes, seconds) };
};

export const fireImpressionOnce = (
    hasFiredRef: { current: boolean },
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    context: SSFloatyAnalyticsContext,
): void => {
    if (hasFiredRef.current) return;
    hasFiredRef.current = true;
    impressionSSFloatyEvent(impressionEvent, context);
};

export const resetImpressionOnce = (hasFiredRef: { current: boolean }): void => {
    hasFiredRef.current = false;
};

export const impressionSSFloatyEvent = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    context: SSFloatyAnalyticsContext,
): void => {
    if (typeof impressionEvent !== "function") return;
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_SS_FLOATY,
        context: JSON.stringify(context),
    });
};

export const clickSSFloatyCloseEvent = (
    clickEvent: AnalyticsContextValue["clickEvent"],
    context: SSFloatyAnalyticsContext,
): void => {
    if (typeof clickEvent !== "function") return;
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_SS_FLOATY_CLOSE,
        context: JSON.stringify(context),
    });
};
